export default __webpack_public_path__ + "static/media/logo_euroins.eecf637c.svg";